/*
 * Parfumelo - livrare gratuita, popup la adaugarea in cos si recomandari
 * inainte de checkout.
 *
 * Nu incarca nicio biblioteca externa. Confettiul e desenat pe un canvas de
 * ~40 de linii, nu cu un pachet de zeci de kilobytes.
 *
 * Sursele de adevar pentru cos sunt doua: evenimentul `cart:update` emis de
 * Horizon si, ca plasa de siguranta, interceptarea cererilor catre /cart/*.
 * Unele fluxuri (quick add, stergere din drawer) nu trec prin acelasi cod.
 */
(function () {
  'use strict';

  /* ---------- configurare ---------- */

  var CFG = { prag: 89900, confetti: true, popupCos: true, popupCheckout: true, recomandate: [] };
  try {
    var brut = document.getElementById('parfumelo-config');
    if (brut) CFG = Object.assign(CFG, JSON.parse(brut.textContent));
  } catch (e) {
    /* ramanem pe valorile implicite */
  }

  var CHEIE_SARBATORIT = 'parfumelo:livrare-sarbatorita';

  /* ---------- stare ---------- */

  var cos = null;          // ultimul /cart.js
  var totalAnterior = null; // pentru detectarea trecerii pragului
  var numarAnterior = null;
  var ultimAdaugat = null;  // produsul din ultimul /cart/add.js
  var upsellAratat = false; // o singura data per incercare de checkout
  var declansatorCheckout = null;

  /* ---------- utilitare ---------- */

  function miscareRedusa() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // Pentru fraze ("mai adauga produse de 150 lei"), unde "lei" se citeste firesc.
  function bani(centi) {
    var v = (centi || 0) / 100;
    var s = v % 1 === 0 ? String(v) : v.toFixed(2).replace('.', ',');
    return s + ' lei';
  }

  // Pentru preturi afisate ca etichete. Acelasi format ca pe restul magazinului:
  // 250.00 MDL, 1,050.00 MDL. Shopify randeaza asa peste tot in tema.
  function pretSite(centi) {
    var s = ((centi || 0) / 100).toFixed(2).split('.');
    s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return s.join('.') + ' MDL';
  }

  function sesiuneScrie(cheie, val) {
    try { window.sessionStorage.setItem(cheie, val); } catch (e) {}
  }
  function sesiuneCiteste(cheie) {
    try { return window.sessionStorage.getItem(cheie); } catch (e) { return null; }
  }

  function el(tag, clasa, text) {
    var n = document.createElement(tag);
    if (clasa) n.className = clasa;
    if (text != null) n.textContent = text;
    return n;
  }

  /* ---------- cos ---------- */

  function reincarcaCos() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        // fara try/catch aici, orice eroare din aplicaCos ar fi inghitita tacut
        // de catch-ul de mai jos, care e doar pentru esecuri de retea
        try { aplicaCos(c); } catch (e) { console.error('[parfumelo] aplicaCos', e); }
        return c;
      })
      .catch(function () { return null; });
  }

  function aplicaCos(c) {
    var primaRulare = cos === null;
    cos = c;

    asezaBare();
    actualizeazaBare();
    asezaIdeeaCadou();

    // pragul se masoara pe produsele livrabile, nu pe totalul cosului
    var livrabil = totalLivrabil();
    var trecutPrag = totalAnterior !== null && totalAnterior < CFG.prag && livrabil >= CFG.prag;
    var subPrag = livrabil < CFG.prag;
    var primulProdus = numarAnterior === 0 && c.item_count > 0;

    if (subPrag) sesiuneScrie(CHEIE_SARBATORIT, '');

    var sarbatorim = trecutPrag && sesiuneCiteste(CHEIE_SARBATORIT) !== '1';

    if (sarbatorim) {
      sesiuneScrie(CHEIE_SARBATORIT, '1');
      pulseazaCos();
      if (CFG.confetti) confetti();
      arataFelicitarea();
    }

    // Daca prima adaugare atinge deja pragul, popupul ar acoperi confettiul si
    // ar spune „mai ai 0 lei". Ramane doar mesajul de felicitare.
    if (!primaRulare && primulProdus && CFG.popupCos && !sarbatorim) {
      deschidePopupAdaugat();
    }

    totalAnterior = livrabil;
    numarAnterior = c.item_count;
  }

  function produseleDinCos() {
    if (!cos || !cos.items) return [];
    return cos.items.map(function (i) { return i.product_id; });
  }

  /* ---------- carduri cadou ---------- */

  // Un card cadou digital nu se livreaza, deci nu are ce cauta in calculul
  // pragului de livrare gratuita. /cart.js marcheaza liniile cu
  // requires_shipping: false, ceea ce acopera si alte produse digitale.
  function esteDigital(linie) {
    return linie && linie.requires_shipping === false;
  }

  function totalLivrabil() {
    if (!cos || !cos.items) return 0;
    return cos.items.reduce(function (s, i) {
      return esteDigital(i) ? s : s + (i.final_line_price != null ? i.final_line_price : i.line_price);
    }, 0);
  }

  function areProduseLivrabile() {
    if (!cos || !cos.items) return false;
    return cos.items.some(function (i) { return !esteDigital(i); });
  }

  /* ---------- bara de livrare gratuita ---------- */

  function faBara() {
    var b = el('div', 'pf-ship');
    b.setAttribute('role', 'status');
    b.setAttribute('aria-live', 'polite');
    b.appendChild(el('p', 'pf-ship__mesaj'));
    var bara = el('div', 'pf-ship__bara');
    bara.appendChild(el('div', 'pf-ship__umplere'));
    b.appendChild(bara);
    return b;
  }

  // Acelasi container `.cart__ctas` exista si in drawer, si pe pagina cosului,
  // deci o singura ancora acopera ambele.
  function asezaBare() {
    var ctas = document.querySelectorAll('.cart__ctas');
    Array.prototype.forEach.call(ctas, function (c) {
      var gazda = c.parentElement;
      if (!gazda) return;
      var existenta = gazda.querySelector('.pf-ship');
      if (existenta) return;
      gazda.insertBefore(faBara(), c);
    });
  }

  function actualizeazaBare() {
    if (!cos) return;
    // numai produsele care chiar se livreaza conteaza pentru prag
    var total = totalLivrabil();
    var lipsa = Math.max(0, CFG.prag - total);
    var procent = CFG.prag > 0 ? Math.min(100, Math.round((total / CFG.prag) * 100)) : 100;
    var gata = lipsa === 0;

    Array.prototype.forEach.call(document.querySelectorAll('.pf-ship'), function (b) {
      // cu un cos numai de carduri cadou, mesajul despre livrare n-are sens
      b.hidden = cos.item_count === 0 || !areProduseLivrabile();
      b.classList.toggle('pf-ship--gata', gata);
      var m = b.querySelector('.pf-ship__mesaj');
      if (m) {
        m.textContent = gata
          ? 'Felicitări, ai primit livrare gratuită'
          : 'Mai adaugă produse de ' + bani(lipsa) + ' și primești livrare gratuită';
      }
      var u = b.querySelector('.pf-ship__umplere');
      if (u) u.style.width = procent + '%';
    });
  }

  /* ---------- pulsul cosului ---------- */

  function pulseazaCos() {
    if (miscareRedusa()) return;
    var t = document.querySelector('.cart-bubble') ||
            document.querySelector('cart-icon') ||
            document.querySelector('.header-actions__cart-icon');
    if (!t) return;
    t.classList.remove('pf-puls');
    void t.offsetWidth; // reporneste animatia
    t.classList.add('pf-puls');
    window.setTimeout(function () { t.classList.remove('pf-puls'); }, 700);
  }

  /* ---------- mesajul de felicitare ---------- */

  // Insoteste confettiul si dispare singur. Confettiul se vede, dar nu spune
  // nimic; textul explica de ce sarbatorim.
  function arataFelicitarea() {
    var vechi = document.getElementById('pf-felicitare');
    if (vechi) vechi.remove();

    var m = el('div', 'pf-felicitare');
    m.id = 'pf-felicitare';
    m.setAttribute('role', 'status');
    m.setAttribute('aria-live', 'polite');
    m.innerHTML =
      '<span class="pf-felicitare__bifa" aria-hidden="true">✓</span>' +
      '<span><strong>Felicitări!</strong> Acum nu mai plătești livrarea.</span>';
    document.body.appendChild(m);

    // dublu rAF, ca tranzitia de intrare sa aiba de unde porni
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { m.classList.add('pf-felicitare--vizibil'); });
    });

    window.setTimeout(function () {
      m.classList.remove('pf-felicitare--vizibil');
      window.setTimeout(function () { if (m.parentNode) m.remove(); }, 400);
    }, 4200);
  }

  /* ---------- confetti ---------- */

  function confetti() {
    if (miscareRedusa()) return;
    if (document.getElementById('pf-confetti')) return;

    var L = window.innerWidth, I = window.innerHeight;
    // Intr-un tab ascuns requestAnimationFrame nu ruleaza si fereastra
    // raporteaza 0x0: am lasa in pagina un canvas mort. Sarim peste.
    if (document.hidden || !L || !I) return;

    var c = el('canvas');
    c.id = 'pf-confetti';
    c.setAttribute('aria-hidden', 'true');
    document.body.appendChild(c);

    var ctx = c.getContext('2d');
    var dpr = window.devicePixelRatio || 1;
    c.width = L * dpr; c.height = I * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    // plasa de siguranta daca tabul e ascuns la mijlocul animatiei
    var curatare = window.setTimeout(function () { if (c.parentNode) c.remove(); }, 4000);

    var culori = ['#C3A15F', '#104556', '#DCEEF2', '#357A55', '#A64235'];
    var bucati = [];
    for (var i = 0; i < 70; i++) {
      bucati.push({
        x: L / 2 + (Math.random() - 0.5) * L * 0.6,
        y: I * 0.3 + Math.random() * 40,
        vx: (Math.random() - 0.5) * 5,
        vy: Math.random() * -7 - 2,
        r: 3 + Math.random() * 4,
        rot: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.3,
        col: culori[i % culori.length],
      });
    }

    var pornit = performance.now();
    var DURATA = 1600;

    function cadru(t) {
      var trecut = t - pornit;
      ctx.clearRect(0, 0, L, I);
      for (var j = 0; j < bucati.length; j++) {
        var q = bucati[j];
        q.vy += 0.22;
        q.x += q.vx;
        q.y += q.vy;
        q.rot += q.vr;
        ctx.save();
        ctx.translate(q.x, q.y);
        ctx.rotate(q.rot);
        ctx.globalAlpha = Math.max(0, 1 - trecut / DURATA);
        ctx.fillStyle = q.col;
        ctx.fillRect(-q.r, -q.r * 0.6, q.r * 2, q.r * 1.2);
        ctx.restore();
      }
      if (trecut < DURATA) window.requestAnimationFrame(cadru);
      else { window.clearTimeout(curatare); c.remove(); }
    }
    window.requestAnimationFrame(cadru);
  }

  /* ---------- schelet de popup ---------- */

  var popDeschis = null;

  function deschidePopup(titlu, construieste) {
    inchidePopup();

    // Sertarul de cos este un <dialog> deschis cu showModal(), deci sta in
    // "top layer"-ul browserului. Top layer bate orice z-index: un simplu div
    // ramane dedesubt, nu primeste focus si niciun buton al lui nu primeste
    // clic. De aceea popupul trebuie sa fie tot un <dialog> modal - ultimul
    // promovat in top layer este cel de deasupra.
    var pop = el('dialog', 'pf-pop');
    pop.setAttribute('aria-label', titlu);

    var fundal = el('div', 'pf-pop__fundal');
    fundal.addEventListener('click', inchidePopup);

    var cutie = el('div', 'pf-pop__cutie');
    var inchide = el('button', 'pf-pop__inchide');
    inchide.type = 'button';
    inchide.setAttribute('aria-label', 'Închide');
    inchide.innerHTML = '&times;';
    inchide.addEventListener('click', inchidePopup);

    cutie.appendChild(inchide);
    cutie.appendChild(el('h2', 'pf-pop__titlu', titlu));
    construieste(cutie);

    pop.appendChild(fundal);
    pop.appendChild(cutie);
    document.body.appendChild(pop);
    popDeschis = pop;
    if (typeof pop.showModal === 'function') pop.showModal();

    window.setTimeout(function () {
      var primul = cutie.querySelector('.pf-btn, button, a');
      if (primul) primul.focus();
    }, 30);

    document.addEventListener('keydown', peEscape);
    return cutie;
  }

  function peEscape(ev) { if (ev.key === 'Escape') inchidePopup(); }

  function inchidePopup() {
    if (popDeschis) {
      if (popDeschis.open && typeof popDeschis.close === 'function') popDeschis.close();
      popDeschis.remove();
      popDeschis = null;
    }
    document.removeEventListener('keydown', peEscape);
  }

  /* ---------- popup la primul produs adaugat ---------- */

  function deschidePopupAdaugat() {
    var item = ultimAdaugat || (cos.items && cos.items[cos.items.length - 1]);
    if (!item) return;
    var aratamLivrarea = areProduseLivrabile();

    deschidePopup('Produs adăugat în coș', function (cutie) {
      var card = el('div', 'pf-adaugat');
      var poza = item.image || item.featured_image || (item.featured_image && item.featured_image.url);
      if (poza) {
        var img = el('img', 'pf-adaugat__poza');
        img.src = String(poza).indexOf('?') > -1 ? poza + '&width=200' : poza + '?width=200';
        img.alt = '';
        card.appendChild(img);
      } else {
        card.appendChild(el('div', 'pf-adaugat__poza'));
      }
      var info = el('div');
      info.appendChild(el('p', 'pf-adaugat__titlu', item.product_title || item.title || ''));
      info.appendChild(el('p', 'pf-adaugat__pret', pretSite(item.final_line_price != null ? item.final_line_price : item.price)));
      card.appendChild(info);
      cutie.appendChild(card);

      var rez = el('div', 'pf-rezumat');
      var r1 = el('div', 'pf-rezumat__rand pf-rezumat__rand--total');
      r1.appendChild(el('span', null, 'Total coș'));
      r1.appendChild(el('span', null, pretSite(cos.total_price)));
      rez.appendChild(r1);

      // Cu un cos numai de carduri cadou nu exista livrare de discutat.
      if (!aratamLivrarea) {
        var rd = el('div', 'pf-rezumat__rand');
        rd.appendChild(el('span', null, 'Livrare'));
        rd.appendChild(el('span', null, 'Card digital, fără transport'));
        rez.appendChild(rd);
      }
      cutie.appendChild(rez);

      // Un rand de text era prea sters pentru informatia cea mai motivanta
      // din popup. Punem aceeasi bara ca in cos; actualizeazaBare() o umple
      // imediat ce intra in pagina, pentru ca tinteste toate `.pf-ship`.
      if (aratamLivrarea) {
        var bara = faBara();
        bara.classList.add('pf-ship--popup');
        cutie.appendChild(bara);
        actualizeazaBare();
      }

      var act = el('div', 'pf-actiuni');

      var continua = el('button', 'pf-btn pf-btn--gol', 'Continuă cumpărăturile');
      continua.type = 'button';
      continua.addEventListener('click', inchidePopup);
      act.appendChild(continua);

      var vezi = el('a', 'pf-btn pf-btn--plin', 'Vezi coșul');
      vezi.href = '/cart';
      vezi.addEventListener('click', function (ev) {
        // Cu cos de tip drawer deschidem panoul in loc sa schimbam pagina.
        // Apelam direct metoda componentei: butonul foloseste legarea
        // declarativa `on:click="/open"` a temei, care nu raspunde la un
        // click sintetic. Daca metoda lipseste, linkul catre /cart ramane.
        if (CFG.tipCos !== 'drawer') { inchidePopup(); return; }
        var comp = document.querySelector('cart-drawer-component');
        if (comp && typeof comp.open === 'function') {
          ev.preventDefault();
          inchidePopup();
          comp.open();
        } else {
          inchidePopup();
        }
      });
      act.appendChild(vezi);

      cutie.appendChild(act);
    });
  }

  /* ---------- recomandari inainte de checkout ---------- */

  function recomandateEligibile() {
    var inCos = produseleDinCos();
    return (CFG.recomandate || [])
      .filter(function (p) {
        if (!p || !p.variantaId) return false;
        if (inCos.indexOf(p.id) !== -1) return false;
        // cardul cadou apare la checkout doar daca e pornit din setari
        if (p.cardCadou && !CFG.cardInRecomandari) return false;
        return true;
      })
      .slice(0, 3);
  }

  /* ---------- sugestia de card cadou din cos ---------- */

  function asezaIdeeaCadou() {
    if (!CFG.cardInCos || !cos || cos.item_count === 0) return;
    // daca deja are un card in cos, sugestia devine redundanta
    var areCard = (cos.items || []).some(esteDigital);
    Array.prototype.forEach.call(document.querySelectorAll('.cart__ctas'), function (c) {
      var gazda = c.parentElement;
      if (!gazda) return;
      var existenta = gazda.querySelector('.pf-gc-idee');
      if (areCard) { if (existenta) existenta.remove(); return; }
      if (existenta) return;
      var d = el('div', 'pf-gc-idee');
      d.innerHTML =
        '<span aria-hidden="true">🎁</span>' +
        '<span>Cauți un cadou? <a href="' + (CFG.urlCarduriCadou || '/products/card-cadou-parfumelo') +
        '">Vezi cardurile cadou</a> — destinatarul își alege singur parfumul.</span>';
      gazda.insertBefore(d, c);
    });
  }

  function deschidePopupCheckout(produse) {
    deschidePopup('Poate te interesează și', function (cutie) {
      var lista = el('div', 'pf-reco');

      produse.forEach(function (p) {
        var rand = el('div', 'pf-reco__item');

        if (p.imagine) {
          var img = el('img', 'pf-reco__poza');
          img.src = p.imagine; img.alt = ''; img.loading = 'lazy';
          rand.appendChild(img);
        } else {
          rand.appendChild(el('div', 'pf-reco__poza'));
        }

        var cont = el('div', 'pf-reco__continut');
        var a = el('a', 'pf-reco__titlu', p.titlu);
        a.href = p.url;
        cont.appendChild(a);
        cont.appendChild(el('span', 'pf-reco__pret', pretSite(p.pret)));
        rand.appendChild(cont);

        var add = el('button', 'pf-btn pf-btn--gol pf-reco__adauga', 'Adaugă');
        add.type = 'button';
        add.addEventListener('click', function () {
          add.disabled = true;
          add.textContent = 'Se adaugă…';
          adaugaInCos(p.variantaId)
            .then(function (ok) {
              add.textContent = ok ? 'Adăugat' : 'Indisponibil';
              if (!ok) add.disabled = false;
            });
        });
        rand.appendChild(add);

        lista.appendChild(rand);
      });

      cutie.appendChild(lista);

      var act = el('div', 'pf-actiuni');
      var inapoi = el('button', 'pf-btn pf-btn--gol', 'Înapoi la coș');
      inapoi.type = 'button';
      inapoi.addEventListener('click', inchidePopup);
      act.appendChild(inapoi);

      var mergi = el('button', 'pf-btn pf-btn--plin', 'Continuă către checkout');
      mergi.type = 'button';
      mergi.addEventListener('click', function () {
        inchidePopup();
        continuaLaCheckout();
      });
      act.appendChild(mergi);

      cutie.appendChild(act);
    });
  }

  function continuaLaCheckout() {
    // upsellAratat este deja true, deci al doilea click trece mai departe
    if (declansatorCheckout && document.contains(declansatorCheckout)) {
      declansatorCheckout.click();
    } else {
      window.location.href = '/checkout';
    }
  }

  function adaugaInCos(variantaId, cantitate) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantaId, quantity: cantitate || 1 }] }),
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: {} } }));
        return reincarcaCos().then(function () { return true; });
      })
      .catch(function () { return false; });
  }

  /* ---------- interceptarea checkoutului ---------- */

  document.addEventListener(
    'click',
    function (ev) {
      if (!CFG.popupCheckout || upsellAratat) return;
      var t = ev.target && ev.target.closest
        ? ev.target.closest('[name="checkout"], a[href^="/checkout"], a[href*="/checkouts/"]')
        : null;
      if (!t) return;

      var produse = recomandateEligibile();
      if (!produse.length) return; // nimic de aratat, il lasam sa treaca

      ev.preventDefault();
      ev.stopPropagation();
      upsellAratat = true;
      declansatorCheckout = t;
      deschidePopupCheckout(produse);
    },
    true
  );

  /* ---------- prinderea modificarilor de cos ---------- */

  document.addEventListener('cart:update', function () {
    window.setTimeout(reincarcaCos, 40);
  });

  // Plasa de siguranta: unele fluxuri nu emit cart:update.
  try {
    var fetchOriginal = window.fetch;
    window.fetch = function (intrare, optiuni) {
      var url = typeof intrare === 'string' ? intrare : (intrare && intrare.url) || '';
      var raspuns = fetchOriginal.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        raspuns
          .then(function (r) {
            if (/\/cart\/add/.test(url) && r && r.ok) {
              r.clone().json().then(function (d) {
                ultimAdaugat = d && d.items ? d.items[0] : d;
              }).catch(function () {});
            }
            window.setTimeout(reincarcaCos, 60);
          })
          .catch(function () {});
      }
      return raspuns;
    };
  } catch (e) {
    /* daca nu putem interceta, ramanem pe cart:update */
  }

  /* ---------- re-randari de sectiuni ---------- */

  var obs = new MutationObserver(programeaza);
  var asteapta = null;

  function porneste_observator() {
    obs.observe(document.body, { childList: true, subtree: true });
  }

  function programeaza() {
    if (asteapta) return;
    asteapta = window.setTimeout(function () {
      asteapta = null;
      obs.disconnect();
      try {
        asezaBare();
        actualizeazaBare();
        asezaIdeeaCadou();
      } finally {
        porneste_observator();
      }
    }, 120);
  }

  /* ---------- pornire ---------- */

  function porneste() {
    reincarcaCos();
    porneste_observator();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', porneste);
  } else {
    porneste();
  }

  window.ParfumeloCos = {
    reincarca: reincarcaCos,
    adauga: adaugaInCos,
    config: CFG,
    stare: function () { return cos; },
    confetti: confetti,
    puls: pulseazaCos,
  };
})();
